import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { RestService } from "@stdoutsrl/design-kit"
import { api, environment } from "../../environments/environment";
import {  Message } from "@stdoutsrl/design-kit";
import { TranslocoService } from "@jsverse/transloco";
import { LoaderService } from "../service/loader.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styles: [],
  standalone: false,
})
export class LoginComponent {
  constructor(
    private router: Router,
    private rest: RestService,
    private loader: LoaderService,
    private message: Message,
    private translocoService: TranslocoService
  ) {}
  email: string = "";
  password: string = "";
  showPassword = false;
  manageCredentials(variableName: "email" | "password", value: any) {
    if (value?.value) {
      this[variableName] = value?.value;
    }
  }

  recoveryPassword() {
    this.router.navigate(["/recupero-password"]);
  }
  login(t:any) {
    this.loader.on();
    this.rest
      .post(api.endpoint.login, {
        email: this.email,
        password: this.password,
      })
      .subscribe({
        next: (value: any) => {
          this.loader.off(true);
          this.rest.setToken(value.token);
          localStorage.setItem("refreshToken", value.refresh_token);
          localStorage.setItem("user", JSON.stringify(value));
          localStorage.setItem("roleId", value.role_id);
          if(value?.user?.role == 5){
           this.translocoService
              .selectTranslateObject("routes")
              .subscribe((route) => {
                this.router.navigate([route.userProfile.path]);
              });
          }else{
            if(value?.user?.role == 4){
              this.translocoService
              .selectTranslateObject("routes")
              .subscribe((route) => {
                this.router.navigate([route.yourQuizs.path]);
              });
            }else{
             window.location.replace('')}
          }
        },
        error: (value) => {
          this.loader.off(true);
          if (environment.testing) {
            this.rest.setToken("ciao");
            this.translocoService
              .selectTranslateObject("routes")
              .subscribe((route) => {
                this.router.navigate([route.userProfile.path]);
              });
          } else {
            this.message.showMessage(t('alerts.'+value?.error?.message), "error");
          }
        },
      });
  }

  registration() {
    this.router.navigate(["/registrazione"]);
  }
}
